import { RiArrowRightFill } from "react-icons/ri";
import Skeleton from "react-loading-skeleton";

interface StepSkeletonProps {
	count?: number;
}

const StepSkeleton = ({ count = 3 }: StepSkeletonProps) => {
	return (
		<>
			{Array.from({ length: count }).map((_, index) => (
				<div className="d-flex h-100 align-items-center ms-1" key={index}>
					<Skeleton key={index} width={100} height={20} />
					{index !== count - 1 && <div className="ms-1"><RiArrowRightFill size={20} /></div>}
				</div>
			))}
		</>
	);
};

export default StepSkeleton;
